/**
 * 프로젝트 관련 상수
 */

/** 프로젝트 타입 라벨 */
export const PROJECT_TYPE_LABELS: Record<string, string> = {
  PERFORMANCE_CHECK: "성능점검",
  MAINTENANCE: "유지관리",
};

/** 프로젝트 상태 라벨 */
export const PROJECT_STATUS_LABELS: Record<string, string> = {
  IN_PROGRESS: "진행중",
  COMPLETED: "완료",
  PENDING: "대기",
};
